import { DetailedHTMLProps, forwardRef, TextareaHTMLAttributes, useId } from 'react';
import { describedBy } from '../fieldMessages';

interface TextAreaProps extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
    label?: string;
    classNames?: string;
    error?: any;
    errorMessage?: string;
    textAreaClassNames?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
        {
            name,
            onChange,
            onBlur,
            label,
            value,
            error,
            errorMessage,
            classNames = '',
            textAreaClassNames = '',
            children,
            id,
            'aria-describedby': ariaDescribedBy,
            ...props
        }: TextAreaProps,
        ref
    ) => {
        const generatedId = useId();
        const textAreaId = id ?? generatedId;
        const errorId = `${textAreaId}-error`;
        return (
            <div className={`group relative w-full clear-both ${classNames ? classNames : 'mb-10'}`}>
                {label && (
                    <label htmlFor={textAreaId} className="block text-sm">
                        {label}
                    </label>
                )}
                <div className="h-full flex justify-between">
                    <textarea
                        id={textAreaId}
                        name={name}
                        onChange={onChange}
                        onBlur={onBlur}
                        className={`w-full min-h-20 max-h-120 bg-transparent outline-hidden py-input-vert text-base ${textAreaClassNames}`}
                        value={value}
                        ref={ref}
                        {...props}
                        aria-invalid={error ? true : undefined}
                        aria-describedby={describedBy(ariaDescribedBy, !!error && errorId)}
                    />
                    {children}
                </div>
                <div className={`${error !== undefined ? 'bg-warning' : 'bg-black group-hover:bg-primary group-focus-within:bg-primary'} input-border`} />
                {error && (
                    <p id={errorId} className="error-message">
                        {errorMessage}
                    </p>
                )}
            </div>
        );
    }
);
